"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f47 = void 0;
exports.f47 = {
    "/gui": [
        2713
    ],
    "/kam": [
        8400
    ],
    "/kama-ka !ke": [
        8400
    ],
    "/xam": [
        8400
    ]
};
